// en, de, fr, pt
export default {
    en: {
        PleaseLoginFirst: "Please login first to add to favorite",
        RecentlyViewed: "Recently Viewed",
        NewAudioArrivals: "New Audio Arrivals",
        CopticBaner: "Coptic Library ",
        Ourlatestnewsandlearningarticles: "Our latest news and learning articles",
        YourName: "Your Name",
        contentBanar: "Coptic Library is a website led by a group of Servants in the Coptic Orthodox Church.This website attempts to offer all Coptic Orthodox books,   audios,  videos, and making a huge impact on the Christian libraries.The 'Coptic Library' website works on making the largest Coptic Orthodox library,including the most important books of both modern and ancient Coptic heritage, to save them from oblivion.Furthermore we aim to publish books with the righteous faith nature,        which does not include what is opposite to the faith and teaching of our Coptic Orthodox Church.We also aim not to publish any books that include contradictory teaching with our Coptic Orthodox Church,which we received from the Church’ s Fathers.The website works on providing an immaculate source to everyone lookingfor knowledge,especially books, in our Coptic Orthodox Church.",

        Email: "Email ",
        Messages: "Messages",
        "Don'tHaveAccount": "Don't Have Account?",
        ChooseCategory: "Choose Category",
        DescriptionOfAttachment: "Description Of Attachment",
        LoginAttempt: "Login Attempt",
        Youarealreadyloggedin: "You are already logged in!",
        ProjectTitle: "SchoolU",
        SendUsMessage: "Send Us Message",
        GetinTouch: "Get in Touch",
        AddNew: "Add New",
        Action: "Action",
        NameAr: "Arabic Name",
        OurLocation: "Our Location",
        ContactInfo: "Contact Info",
        ContactUs: "Contact Us",
        NameEn: "English Name",
        showNoDataAvailable: "No data available... Please try again",
        NoNotesAvailable: "No notes available",
        SorryYouAccountisNotActive: "Sorry..You account is not active",
        WelcomeMsg: "Welcome back, Please login to your account.",
        Update: "Update",
        showError: "Something went wrong... Please try again",
        showUpdate: "Record updated successfully...",
        showCheckEmail: "Kindly check you email for new password...",
        showPasswordChanged: "Password changed...",
        NameFr: "French Name",
        AddressAr: "Arabic Adress",
        AddressEn: "English Adress",
        AddressFr: "French Adress",
        NoteAr: "Arabic Note",
        NoteEn: "English Note",
        NoteFr: "French Note",
        AboutUsAr: "Arabic AboutUs",
        AboutUsEn: "English AboutUs",
        AboutUsFr: "French AboutUs",
        Logo: "Logo",
        SendVertificationCode: "Send Vertification Code",
        Cancel: "Cancel",
        Delete: "Delete",
        PhoneNumber: "Phone Number",
        VertificationCode: "Vertification Code",
        Vertify: "Vertify",
        MainInfo: "Main Info",
        LoginInfo: "Login Info",
        Save: "Save",
        Email: "Email",
        Password: "Password",
        Bus: "Bus",
        Buses: "Buses",
        Attachment: "Attachment",
        Installments: "Installments",
        Installment: "Installment",
        Stage: "Stage",
        StageYear: "Stage Year",
        Class: "Class",
        Age: "Age",
        Subjects: "Subjects",
        About: "About",
        NewAttachment: "New Attachment",
        AddAttachment: "Add Attachment",
        Description: "Description",
        KnowMoreAboutUs: "Know More About Us",

        URL: "URL",
        File: "File",
        NewBus: "New Bus",
        AddBus: "Add Bus",
        ModelAr: "Arabic Model",
        ModelEn: "English Model",
        ModelFr: "French Model",
        IsActive: "Active",
        AddInstallment: "Add Installment",
        NewInstallment: "New Installment",
        InstallmentTypeEn: "Installment Type English NAme",
        PayDate: "Pay Date",
        IsPaid: "Paid",
        Routes: "Routes",
        Users: "Users",
        Students: "Students",
        Teachers: "Teachers",
        Drivers: "Drivers",
        StudentExam: "Student Exam",
        StudentExamAnswer: "Student Exam Answer",
        ExaminationManagement: "Examination Management",
        QuestionBank: "Question Bank",
        ExamRule: "Exam Rule",
        ExamGeneration: "Exam Generation",
        Setting: "Setting",
        Date: "Date",
        ClassSessionName: "Session",
        SubjectName: "Subject",
        FromDate: "From",
        ToDate: "To",
        ClassSession: "Session",
        ClassSchedule: "Class Schedule",
        ClassScheduleAddEdit: "Class Schedule Add/Edit",
        Status: "Status",
        SchoolInfo: "School Info",
        AssessmentType: "Assessment Type",
        BusSuperVisor: "Bus SuperVisor",
        Language: "Language",
        GradeType: "Grade Type",
        ExamType: "Exam Type",
        QuestionLevel: "Question Level",
        QuestionType: "Question Type",
        Stages: "Stages",
        StageYears: "Stage Years",
        InstallmentType: "Installment Type",
        Name: "Name",
        Reset: "Reset",
        UserWithSamePhoneNumberExist: "User With Same Phone Number Exist",
        SomethingWentWrong: "Something Went Wrong",
        CodeIsNotExist: "Code Is Not Exist",
        Welcome: "Welcome",
        Modules: "Modules",
        SignUp: "Sign Up",
        Newlanguage: "New language",
        AddLanguage: "Add Language",
        NewModule: "New Module",
        AddModule: "Add Module",
        Module: "Module",
        Route: "Route",
        Details: "Details",
        AddRouteDetails: "Add Route Details",
        Longitude: "Longitude",
        Latitude: "Latitude",
        Region: "Region",
        NewRouteDetails: "New Route Details",
        Model: "Model",
        BusSupervisor: "Bus supervisor",
        Driver: "Driver",
        DriverAddEdit: "Driver Add/Edit",
        AddDriver: "Add Driver",
        NewDriver: "New Driver",
        Classes: "Classes",
        NewSubject: "New Subject",
        Subject: "Subject",
        Teacher: "Teacher",
        NewClass: "New Class",
        TeacherAddEdit: "Teacher Add/Edit",
        SubjectMaxScore: "Subject Max Score",
        AddSubject: "Add Subject",
        QuestionNum: "Number of questions",
        QuestionAr: "Arabic Question",
        QuestionEn: "English Question",
        QuestionFr: "French Question",
        NewQuestion: "New Question",
        Question: "Question",
        Answers: "Answers",
        AnswerAr: "Arabic Answer",
        AnswerEn: "Englisg Answer",
        AnswerFr: "French Answer",
        IsRight: "IsRight",
        Addanswer: "Add Answer",
        DescriptionAr: "Arabic Description",
        DescriptionEn: "English Description",
        DescriptionFr: "French Description",
        Download: "Download",
        Type: "Type",
        AddRule: "Add Rule",
        NewRule: "New Rule",
        RuleInfo: "Rule Info",
        ExamStartDate: "Start Date",
        Exams: "Exams",
        TimeOfExamInMinutes: "Exam Time In Minutes",
        Generate: "Generate",
        ExamMainInfo: "Exam Main Info",
        GenerateQuestions: "Generate Questions",
        Text: "Text",
        TrueFalse: "True/False",
        MultiChoose: "Multi Choose",
        TimeInMinute: "Time In Minute",
        Weight: "Weight",
        TypeAr: "Arabic Type",
        TypeEn: "English Type",
        TypeFr: "French Type",
        UPDATE: "Update",
        Amount: "Amount",
        InstallmentDate: "Installment Date",
        DeadLine: "DeadLine",
        LevelAr: "Arabic Level",
        LevelEn: "English Level",
        LevelFr: "French Level",
        EventType: "Event Type",
        Events: "Events",
        SchoolArchitecture: "School Architecture",
        UserType: "User Type",
        RelatedAccounts: "Related Accounts",
        UserManagment: "User Managment",
        SubjectManagment: "Subject Managment",
        StageYearSubjects: "Stage Year Subjects",
        SubjectModules: "Subject Modules",
        BuseManagment: "Bus Managment",
        EventManagment: "Event Managment",
        InstallmentManagment: "Installment Managment",
        Grade: "Grade",
        Active: "Active",
        Inactive: "Inactive",
        True: "True",
        False: "False",
        CustomUser: "Custom User",
        AllDriver: "All Driver",
        AllTeacher: "All Teacher",
        AllParent: "All Parent",
        StudentTeacherInstallments: "Student/Teacher Installments",
        User: "User",
        Success: "Success",
        CreatedSuccessfully: "Created Successfully",
        UpdatedSuccessfully: "Updated Successfully",
        Error: "Error",
        CreatedFailed: "Created Failed",
        UpdatedFailed: "Updated Failed",
        DeletedSuccessfully: "Deleted Successfully",
        DeleteFailed: "Delete Failed",
        Confirm: "Confirm",
        DeleteConfirmText: "Are you sure you want delete this record?",
        ErrorTryLater: "SomeThing went wrong , please try later ..",

        Dashboard: "Dashboard",
        eCommerce: "eCommerce",
        Apps: "Apps",
        Todo: "Todo",
        Chat: "Chat",
        Calendar: "Calendar",
        FullCalendar: "Full Calendar",
        SimpleCalendar: "Simple Calendar",
        Shop: "Shop",
        Cart: "Cart",
        WishList: "Wish List",
        Checkout: "Checkout",
        UI: "UI",
        DataList: "Data List",
        ListView: "List View",
        ThumbView: "Thumb View",
        Grid: "Grid",
        Vuexy: "Vuexy",
        Vuesax: "Vuesax",
        Tailwind: "Tailwind",
        Colors: "Colors",
        Card: "Card",
        Basic: "Basic",
        Statistics: "Statistics",
        Analytics: "Analytics",
        CardActions: "Card Actions",
        CardColors: "Card Colors",
        Table: "Table",
        agGridTable: "agGrid Table",
        Components: "Components",
        Alert: "Alert",
        Avatar: "Avatar",
        Badge: "Badge",
        Breadcrumb: "Breadcrumb",
        Button: "Button",
        ButtonGroup: "Button Group",
        Chip: "Chip",
        Collapse: "Collapse",
        Dialogs: "Dialogs",
        Divider: "Divider",
        DropDown: "DropDown",
        List: "List",
        Loading: "Loading",
        Navbar: "Navbar",
        Notifications: "Notifications",
        Pagination: "Pagination",
        Popup: "Popup",
        Progress: "Progress",
        Sidebar: "Sidebar",
        Slider: "Slider",
        Tabs: "Tabs",
        Tooltip: "Tooltip",
        Upload: "Upload",
        FormsAndTable: "Forms & Table",
        FormElements: "Form Elements",
        Select: "Select",
        Switch: "Switch",
        Checkbox: "Checkbox",
        Radio: "Radio",
        Input: "Input",
        NumberInput: "Number Input",
        Textarea: "Textarea",
        FormLayouts: "Form Layouts",
        FormWizard: "Form Wizard",
        FormValidation: "Form Validation",
        FormInputGroup: "Form Input Group",
        Pages: "Pages",
        Authentication: "Authentication",
        Login: "Login",
        Register: "Register",
        ForgotPassword: "Forgot Password",
        ResetPassword: "Reset Password",
        LockScreen: "Lock Screen",
        Miscellaneous: "Miscellaneous",
        ComingSoon: "Coming Soon",
        404: "404",
        500: "500",
        NotAuthorized: "Not Authorized",
        Maintenance: "Maintenance",
        Profile: "Profile",
        Invoice: "Invoice",
        FAQ: "FAQ",
        Search: "Search",
        KnowledgeBase: "Knowledge Base",
        ChartsAndMaps: "Charts & Maps",
        Charts: "Charts",
        ApexCharts: "Apex Charts",
        chartjs: "chartjs",
        echarts: "echarts",
        chartist: "chartist",
        GoogleMap: "Google Map",
        Extensions: "Extensions",
        QuillEditor: "Quill Editor",
        DragAndDrop: "Drag & Drop",
        Datepicker: "Datepicker",
        DatetimePicker: "Datetime Picker",
        AccessControl: "Access Control",
        I18n: "I18n",
        Carousel: "Carousel",
        Clipboard: "Clipboard",
        ContextMenu: "Context Menu",
        StarRatings: "Star Ratings",
        Autocomplete: "Autocomplete",
        Tree: "Tree",
        Import: "Import",
        Export: "Export",
        ExportSelected: "Export Selected",
        Others: "Others",
        MenuLevels: "Menu Levels",
        MenuLevel2p1: "Menu Level 2.1",
        MenuLevel2p2: "Menu Level 2.2",
        MenuLevel3p1: "Menu Level 3.1",
        MenuLevel3p2: "Menu Level 3.2",
        DisabledMenu: "Disabled Menu",
        Support: "Support",
        Documentation: "Documentation",
        RaiseSupport: "Raise Support",
        demoTitle: "Card Title",
        demoText: "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
        /* custom i18n data */
        Course: "Course",
        CourseCatalog: "Course catalog",
        Instructor: "Instructors",
        Planning: "Planning",
        AnnualPlan: "Annual Plan",
        Facility: "Facility",
        ClassRoom: "Class Room",
        CourseType: "Course Type",
        CourseLevel: "Course Level",
        MaterialType: "Material Type",
        ViewMaterial: "View Material",
        PopulationList: "Population List",
        IndustrySector: "Industry Sector",
        AreaOfStudy: "Area Of Study",
        CourseCategory: "Course Category",
        Nationality: "Nationality",
        MaritalStatus: "Marital Status",
        ContactType: "Contact Type",
        EducationDegree: "Education Degree",
        Customer: "Customer",
        Trainee: "Trainee",
        UserManagement: "User Management",
        Home: "Home",
        YearSummary: "Year Summary",
        CourseClass: "Course Classes",
        QuestionManagement: "Question Management",
        Reports: "Reports",
        CourseRegistration: "Course Registrations",
        CourseRequest: "Course Requests",
        EnrollmentManagement: "Enrollment Management",
        TestManagement: "Test Management",
        CourseExam: "Course Exams",
        QuestionCategory: "Question Category",
        TermsOfUse: "Terms Of Use",
        PrivacyPolicy: "Privacy Policy",
        Imprints: "Imprints",
        NewMaterial: "New Material",
        StudentUserInstallment: "Student/User Installment",
        BusTracking: "Bus Tracking",
        All: "All",
        ChannelBook: "Channel Book",
        ChannelBookType: "Channel Book Type",
        ChannelBookAddEdit: "Channel Book Add/Edit",
        Sender: "Sender",
        Recevier: "Recevier",
        Message: "Message",
        MessageType: "MessageType",
        IsReplyable: "Is Replyable",
        BusSuperVisors: "Bus Super Visors",
        EndDate: "End Date",
        AddSubjects: "Add Subjects",
        ClassTeacherSubject: "Class Teacher Subject",
        Edit: "Edit",
        ThisItemAlreadyExist: "This Item Already Exist",
        AlreadyExist: "Already Exist",
        Material: "Material",
        Logout: "Logout",
        Pdf: "Pdf",
        Video: "Video",
        Image: "Image",
        Document: "Document",
        ExamCode: "Exam Code",
        UpdateImage: "Update Image",
        RemoveImage: "Remove Image",
        WelcomeBack: "Welcome back, please login to your account.",
        RememberMe: "Remember Me",
        SendChannelBook: "Send channel book",
        Data: "Data",
        RelaredAccounts: "Relared accounts ",
        Filters: "Filters",
        StudentInstallmentCounts: "Student installment counts",
        ExamsAndEventsForWeek: "Exams and events for week",
        AllUsers: "All users",
        ExamsForWeek: "Exams for week",
        EventsForWeek: "Events for week",
        AlltInstallmentCounts: "All installment counts",
        PaidInstallmentCount: "Paid installment count",
        UnPaidInstallmentCount: "UnPaid installment count",
        AllChangeRouteRequest: "All change route request count",
        AllChangeRouteRequestPending: "change route request pending count",
        AllChangeRouteRequestRefused: "All change route request refused",
        AllChangeRouteRequestAccept: "All change route request accept",
        StudentBusOffForWeek: "Student bus off for week",
        studentBusOFF: "student number",
        AllRoutesAndBusses: "Routes and busses",
        StudentChangeRouteRequest: "StudentChangeRouteRequest",
        StudentChangeRouteRequestAddEdit: "Add/Edit",
        Accepted: "Accepted",
        AddEdit: "Add/Edit",
        ColorCode: "Color Code",
        SubjectExamRole: "Subject Exam Role",
        BusTrips: "Bus Trips",
        BusTrip: "Bus Trip",
        PublishHouse: "Publish House",
        PageNumber: " Page Number",
        PageNumberBook: " Page Number",

        IBSN: "IBSN ",
        TIMEOFSTART: "Time of start",
        TIMEOFEND: "Time of end",
        PickupLocation: "Adress",
        cantRememberYourPassword: "can't remember your Password ?",
        DaysOfWeek: "Day",
        maxScore: "max score",
        TermsOfUse: "Terms of use",
        SignupusingGoogle: "Signup using Google",
        Signuphere: "Sign up here",
        FirstName: "First Name",
        LastName: "Last name",
        GetStartedForFree: "Get Started For Free",
        AlreadyHaveAnAccount: "Already Have An Account ?",
        ResetItHere: "reset it here",
        publishedby: "published by",
        ReadNow: "Read Now",
        Tableofcontents: "Table of contents",
        FileDownloadedSuccessfuly: "File Downloaded Successfuly",
        SaveEdits: "Save",
        ConfirmPassword: "Confirm Password",
        NewPassword: "New password",
        CurrentPassword: "Current password",
        ChangePassword: "Change password",
        PasswordUpdated: "Password updated",
        YourPasswordHasBeenUpdatedSuccessfully: "Your Password Has Been Updated Successfully",
        BackToHome: "Back To Home",
        showUpdate: "Record updated successfully...",
        ClickHereToShowBrief: "Click Here To Show Brief",
        Brief: "Brief",
        back: "back",
        NumberOfPages: "Number Of Pages",
        DepositNumber: "Deposit Number",
        Subject: "Subject",
        NewBooks: "New Books",
        NewVideoArrivals: "New Video Arrivals",
        AuthorName: "Author Name",
        publishedDate: "published Date",
        ContinueBrief: "Brief",
        PublishDate: "Publish Date",
        Category: "Category",
        NotFound: "This account Not found",
        Complain: "Complain",
        save: "save",
        Title: "Title",
        AuthorNameVideo:"Author Name",
        TitleMessage: "Message Title",
    },
    ar: {
        TitleMessage: "العنوان",
        AuthorNameVideo:"اسم الناشر",
        Title: "العنوان",
        save: "حفظ",
        Complain: "الشكاوي",
        NotFound: "غير موجود",
        Category: "القسم",
        PublishDate: "تاريخ النشر",
        ContinueBrief: "نبذة",
        publishedDate: "تاريخ النشر",
        AuthorName: "اسم الكاتب",
        NewVideoArrivals: "الفيديوهات الجديدة",
        NewBooks: "الكتب الحديثة",
        Subject: "الموضوع ",
        PageNumberBook: "رقم الصفحة",
        NumberOfPages: "عدد الصفح",
        MainInfo: "البيانات الاساسية",
        DepositNumber: "رقم الايداع للكتاب",
        back: "رجوع",
        Brief: "نبذة",
        ClickHereToShowBrief: "اضغط هنا لمشاهدة النبذة",
        showUpdate: "تم التحديث بنجاح ...",
        Update: "تحديث",

        PleaseLoginFirst: "الرجاء تسجيل الدخول أولا لإضافة إلى المفضلة",
        Audio: "صوتيات",
        Video: "فيديو",
        Blogs: "مقالات",
        News: "أخبار",
        Favorite: "المفضلة",
        About: "من نحن",
        RecentlyViewed: "تم عرضها مؤخرًا",
        NewBooks: "كتب جديدة",
        NewAudioArrivals: "صوتيات جديدة",
        NewVideoArrivals: "فيديو جديدة",
        BackToHome: "العودة إلى الرئيسية",
        YourPasswordHasBeenUpdatedSuccessfully: "لقد تم تحديث كلمة السر الخاصة بك بنجاح",
        PasswordUpdated: "تم تحديث كلمة السر",
        ChangePassword: "تغيير كلمة المرور",
        CurrentPassword: "كلمة المرور الحالي",
        NewPassword: " كلمة السر الجديدة",
        Change: "تغيير",
        ConfirmPassword: "تأكيد كلمة المرور",
        SaveEdits: "احفظ",
        FileDownloadedSuccessfuly: "تم تنزيل الملف بنجاح",
        Ops: "عفوًا!",
        Continue: "عرض الكتاب",
        PublishHouse: "دار النشر",
        PageNumber: "عدد الصفحات ",
        IBSN: "رقم الايداع ",
        Tableofcontents: "فهرس المحتوي",

        ReadNow: "اقرا الان",
        publishedby: "نشرت من قبل",
        "Don'tHaveAccount": "ليس لديك حساب؟",
        "Read & Listen": "قراءة & استماع",
        Books: "كتب",
        Videos: "فيديوهات",
        Audios: "صوتيات",
        ResetItHere: "إعادة تعيين هنا",
        AlreadyHaveAnAccount: "هل لديك حساب ؟",
        GetStartedForFree: "يمكنك البدء مجانا",
        FirstName: "الاسم الاول",
        LastName: "اللقب",
        Signuphere: "التسجيل من هنا",
        SignUp: "التسجيل من هنا",
        SignupusingGoogle: "التسجيل باستخدام جوجل",
        or: "او",
        TermsOfUse: "شروط الاستخدام",
        cantRememberYourPassword: "هل نسيت كلمة المرور؟",
        Note: "ملحوظة",
        maxScore: "أقصى درجة",
        DaysOfWeek: "اليوم",
        PickupLocation: "العنوان",
        TIMEOFEND: "تاريخ الانتهاء",
        TIMEOFSTART: "تاريخ البدء",
        BusTrips: "رحلة الاتوبيس",
        BusTrip: "رحلة الاتوبيس",

        Pickup: "مكان استلام",
        Destination: "مكان التوصيل",
        Both: "الكل",
        Content: "المحتوى",
        SubjectExamRole: "قواعد الامتحان ",
        Youarealreadyloggedin: "قد قمت بتسجيل الدخول بالفعل!",
        LoginAttempt: "محاولة تسجيل الدخول",
        showNoDataAvailable: "لا توجد بيانات متاحة ... يرجى المحاولة مرة أخرى",
        NoNotesAvailable: "لا توجد ملاحظات",
        showError: "حدث خطأ ما. أعد المحاولة من فضلك",
        Update: "تحديث",
        showUpdate: "تم التحديث بنجاح ...",
        Event: "الحدث",
        ColorCode: "لون الكود",
        Student: "طالب",
        "Route-Edit": "تعديل-المسار",
        AddEdit: "اضافة/تعديل",
        DescriptionOfAttachment: "وصف الملحقات",
        Accepted: "موافقة",
        Refused: "رفض",
        Pending: "قيد الانتظار",
        StudentChangeRouteRequestAddEdit: "تعديل/اضافة",
        Order: "طلب",
        GetinTouch: "الحصول على اتصال",
        StudentChangeRouteRequest: "طلب تغير مسار الحافلة",
        AllRoutesAndBusses: "خطوط النقل و الحافلات",
        studentBusOFF: "عدد الطلاب",
        StudentBusOffForWeek: "طلبات الغاء الحافلة ",
        AllChangeRouteRequestAccept: "عدد طلبات تغيير المسار المقبولة",
        AllChangeRouteRequestRefused: "عدد طلبات تغيير المسار المرفوضة",
        AllChangeRouteRequestPending: " عدد طلبات تغيير المسار المعلقة",
        AllChangeRouteRequest: " عدد طلبات تغيير الحافلة",
        UnPaidInstallmentCount: "الاقساط غير المسددة",
        PaidInstallmentCount: " الأقساط المدفوعة",
        AlltInstallmentCounts: "جميع الأقساط",
        EventsForWeek: " أحداث الأسبوع",
        ExamsForWeek: " الامتحانات لمدة أسبوع",
        drivers: "السائقين",
        teachers: "المعلمين",
        students: "الطلاب",
        parents: "الاباء",
        AllUsers: " جميع المستخدمين",
        ExamsAndEventsForWeek: " الامتحانات والفعاليات للأسبوع",
        StudentInstallmentCounts: "مجموع أقساط الطلاب",
        Filters: "البحث",
        RelaredAccounts: " الحسابات ذات الصلة",
        Data: " البيانات",
        SendChannelBook: "إرسال مراسلة",
        Send: "ارسال",
        RememberMe: "تذكرنى",
        WelcomeBack: "مرحبًا بك من جديد ، يرجى تسجيل الدخول إلى حسابك.",
        User: "مستخدم",
        StudentTeacherInstallments: "اقساط الطلاب/المستخدمين",
        CustomUser: "مستخدم معين",
        AllDriver: "كل السائقين",
        AllTeacher: "كل المدرسين",
        AllParent: "كل اولياء الامور",
        Parent: "والي امر",
        True: "نعم",
        False: "لا",
        Active: "فعال",
        Inactive: "موقوف",
        ExamCode: "كود الامتحان",
        Pdf: "بي دي إف",
        Video: "فيديو",
        Image: "صورة",
        Document: "ملف",
        Logout: "خروج",
        ThisItemAlreadyExist: "هذا البند موجود من قبل",
        AlreadyExist: "موجود من قبل",
        Edit: "تعديل",
        Material: "ملحقات",
        Ourlatestnewsandlearningarticles: "آخر أخبارنا ومقالاتنا التعليمية",
        MaterialType: "نوع الماتيريال",
        KnowMoreAboutUs: "اعرف المزيد عنا",
        All: "الكل",
        ClassTeacherSubject: "الفصول",
        AddSubjects: "اضافة مواد",
        EndDate: "نهاية المدة",
        Sender: "المرسل",
        Message: "الرسالة",
        MessageType: "نوع الرسالة",
        IsReplyable: "يمكن الرد",
        Recevier: "المرسل اليه",
        ChannelBook: "المراسلات",
        ChannelBookType: "انواع المراسلات",
        ChannelBookAddEdit: "المراسلات اضافة/ تعديل",
        BusTracking: "تتبع الاتوبيسات",
        ProjectTitle: "مدرستك",
        Home: "الرئيسية",
        AddNew: "أضافة",
        Action: "العمليات",
        NameAr: "الاسم بالعربي",
        NameEn: "الاسم بالانجليزي",
        NameFr: "الاسم بالفرانساوي",
        AddressAr: " العنوان بالعربي ",
        AddressEn: "العنوان بالانجليزي",
        AddressFr: "العنوان بالفرانساوي",
        NewMaterial: "اضافة ملحق",
        ViewMaterial: "الملحقات",
        NoteAr: "ملاحظة بالعربي",
        NoteEn: "ملاحظة بالانجليزي",
        NoteFr: "ملاحظة بالفرانساوي",
        ChooseCategory: "اختار تصنيف",
        StudentUserInstallment: "اقساط الطلاب/المستخدمين",
        AboutUsAr: " معلومات عنا بالعربي",
        AboutUsEn: " معلومات عنا بالانجليزي",
        AboutUsFr: " معلومات عنا بالفرانساوي",
        Logo: "لوجو",
        SendVertificationCode: "ارسال رمز التعريف",
        Cancel: "الغاء",
        Delete: "حذف",
        PhoneNumber: "رقم الهاتف",
        VertificationCode: "رمز التعريف",
        Vertify: "تاكيد الرمز",
        MainInfo: "البيانات الاساسية",
        LoginInfo: "بيانات الدخول",
        Save: "حفظ",
        CopticBaner: "المكتبة القبطية الارثوذكسية ",
        Email: "البريد الاكتروني",
        Password: "الرقم السري",
        Buses: "الاتوبيسات",
        Bus: "اتوبيس",
        Attachment: "الملحقات",
        Installments: "الأقساط",
        Installment: "ألقسط",
        Stage: "المرحلة",
        StageYear: "السنة",
        Class: "الفصل",
        Age: "السن",
        Subjects: "المواد",
        NewAttachment: "ملحق جديد",
        AddAttachment: "اضافة ملحق",
        Description: "الوصف",
        URL: "الرابط",
        File: "الملف",
        NewBus: "اضافة اتوبيس",
        AddBus: "اضافة اتوبيس",
        ModelAr: "النموذج بالعربي",
        ModelEn: "النموذج بالانجليزي",
        ModelFr: "النموذج بالفرنساوي",
        IsActive: "فعال",
        InstallmentTypeEn: "اسم نوع القسط بالعربي",
        AddInstallment: "أضافة قسط",
        NewInstallment: "قسط جديد",
        PayDate: "تاريخ الدفع",
        IsPaid: "الدفع",
        Routes: "الطرق",
        Users: "المستخدمين",
        Students: "الطلاب",

        Teachers: "المعلمين",
        Drivers: "السائقين",
        ExaminationManagement: "أدارة الامتحانات",
        QuestionBank: "بنك الاسئلة",
        ExamRule: "قواعد الامتحان",
        ExamGeneration: "انشاء الامتحان",
        Setting: "الاعدادات",
        SchoolInfo: "بيانات المدرسة",
        AssessmentType: "نوع التقيم",
        BusSuperVisors: "مشرفين الاتوبيسات",
        Language: "اللغة",
        GradeType: "نوع الدرجة",
        ExamType: "نوع الامتحان",
        QuestionLevel: "مستوي السؤال",
        QuestionType: "نوع السؤال",
        Stages: "المراحل الدراسية",
        StageYears: "سنين المراحل الدراسية",
        InstallmentType: "نوع القسط",
        Name: "الاسم",
        Reset: "اعادة",
        UserWithSamePhoneNumberExist: "يوجد مستخدم بنفس رقم الهاتف",
        SomethingWentWrong: "حدث خطأ ما",
        CodeIsNotExist: "رمز التعريف خطأ",
        Welcome: "مرحبا بك",
        Date: "التاريخ",
        ClassSessionName: "الحصة",
        SubjectName: "المادة",
        FromDate: "من",
        SendUsMessage: "ارسال رسالة  لنا",
        ToDate: "الي",
        ClassSession: "الحصة",
        ClassSchedule: "جدول الحصص",
        ClassScheduleAddEdit: "جدول الحصص اضافة/ تعديل",
        Status: "الحالة",
        Modules: "النماذج",
        Newlanguage: "لغة جديدة",
        AddLanguage: "اضافة لغة",
        NewModule: "وحدة جديد",
        AddModule: "اضافة وحدة",
        Module: "الوحدة",
        Route: "الطريق",
        YourName: "اسمك",
        Email: "البريد الالكتروني",
        Messages: "رسالتك",
        Details: "التفاصيل",
        AddRouteDetails: "اضافة تفاصيل الطريق",
        Longitude: "خط الطول",
        Latitude: "خط العرض",
        Region: "المنطقة",
        NewRouteDetails: "تقاصيل طريق جديدة",
        Model: "النموذج",
        ContactUs: "تواصل معنا",
        BusSupervisor: "مشرف الاتوبيس",
        Driver: "السائق",
        DriverAddEdit: "السائق اضافة/ تعديل",
        AddDriver: "اضافة سائق",
        NewDriver: "سائق جديد",
        ContactInfo: "معلومات التواصل",
        Classes: "الفصول",
        NewSubject: "مادة جديدة",
        Subject: "المادة",
        Teacher: "المعلم",
        NewClass: "فصل جديد",
        TeacherAddEdit: "المعلم اضافة/ تعديل",
        OurLocation: "موقعنا",
        AddSubject: "اضافة مادة",
        SubjectMaxScore: "درجة المادة",
        StudentExam: "امتحانات الطالب",
        QuestionNum: "عدد الاسئلة",
        QuestionAr: "السؤال بالعربي",
        QuestionEn: "السؤال بالانجليزي",
        QuestionFr: "السؤال بالفرانساوي",
        NewQuestion: " سؤال جديد",
        Question: "السؤال",
        Answers: "الاجابات",
        AnswerAr: "الاجابة بالعربي",
        AnswerEn: "الاجابة بالنجليزي",
        AnswerFr: "الاجابة بالفرانساوي",
        IsRight: "صحيح",
        Addanswer: "اضافة اجابة",
        DescriptionAr: "الوصف بالعربي",
        DescriptionEn: "الوصف بالانجليزي",
        DescriptionFr: "الوصف بالفرانساوي",
        Download: "تحميل",
        Type: "النوع",
        AddRule: "اضافة قاعدة",
        NewRule: "قاعدة جديدة",
        RuleInfo: "بيانات القاعدة",
        ExamStartDate: "تاريخ الامتحان",
        Exams: "الامتحانات",
        TimeOfExamInMinutes: "مدة الامتحان بالدقائق",
        Generate: "انشاء",
        ExamMainInfo: "بيانات الامتحان",
        GenerateQuestions: "انشاء الاسئلة",
        Text: "مقالي",
        TrueFalse: "صح او خطأ",
        MultiChoose: "متعدد الاختيارات",
        TimeInMinute: "المدة بالدقائق",
        Weight: "الدرجة",
        TypeAr: "النوع بالعربي",
        TypeEn: "النوع بالانجليزي",
        TypeFr: "النوع بالفرانساوي",
        UPDATE: "تعديل",
        Amount: "المبلغ",
        InstallmentDate: "تاريخ القسط",
        DeadLine: "الموعد النهائي",
        LevelAr: "المستوي بالعربي",
        LevelEn: "المستوي بالانجليزي",
        LevelFr: "المستوي بالفرانساوي",
        EventType: "نوع الحدث",
        Events: "الاحداث",
        SchoolArchitecture: "اساسيات المدرسة",
        UserType: "نوع المستخدم",
        RelatedAccounts: "الحسابات المرتبطة",
        UserManagment: "ادارة المستخدمين",
        SubjectManagment: "ادارة المواد",
        StageYearSubjects: "مواد المرحلة الدراسية",
        SubjectModules: "ملحقات المادة",
        BuseManagment: "ادارة الاتوبيسات",
        EventManagment: "ادارة الاحداث",
        InstallmentManagment: "ادارة الاقساط",
        Grade: "الدرجة",
        Success: "نجاح",
        contentBanar: "موقع المكتبة القبطية هو موقع يشرف عليه مجموعة من الخدام في الكنيسة القبطية الأرثوذكسية هو موقع يسعي إلى توفير كافة الكتب القبطية الأرثوذكسية، و الصوتيات و الفيديوهات، كما يهدف إلى إحداث أثر كبير في المكتبات المسيحية.وتعمل المكتبة القبطية أيضًا على تكوين أكبر مكتبة قبطية أرثوذكسية تضم أهم كتب التراث القبطي الحديث و القديم بعد؛ حفاظً ا عليها من الاندثار، كما نهدف لنشر الكتب ذات الطابع الإيماني السليم وأيضاً الكتب التي لا يوجد بها ما يخالف أيمان وتعليم الكنيسة القبطية الأرثوذكسية، كما نحرص علي عدم نشر أي كتب تحتوي على اي تعليم تخالف إيماننا القبطي الأرثوذكسي وما تسلمناه من آباء الكنيسة الموقع يعمل على توفير نبع نقي للمعرفة حتى يستقي منه جميع الباحثين عن الكتب بشكل خاص والمعرفة بشكل عام داخل كنيستنا القبطية الأرثوذكسية.  ",

        CreatedSuccessfully: "تم الاضافة بنجاح",
        UpdatedSuccessfully: "تم التعديل بنجاح",
        Error: "خطا",
        CreatedFailed: "لم يتم الاضافة",
        UpdatedFailed: "لم يتم التعديل",
        DeletedSuccessfully: "تم الحذف بنجاح",
        DeleteFailed: "لم يتم الحذف",
        Confirm: "تاكيد",
        DeleteConfirmText: "هل انت متاكد من انك تريد الحذف",
        ErrorTryLater: "حث خطا ما برجاء المحاولة في وقت لاحق",
        Dashboard: "احصائيات",
        eCommerce: "احصائيات",
        StudentExamAnswer: "اجابات الطالب",
        UpdateImage: "اضافة الصورة",
        RemoveImage: "حذف الصورة",
        Apps: "Apps",
        Todo: "Machen",
        Chat: "Plaudern",
        Calendar: "Kalender",
        FullCalendar: "Calendrier completVollständiger Kalender",
        SimpleCalendar: "Einfacher Kalender",
        Shop: "Geschäft",
        Cart: "Wagen",
        WishList: "Wunschzettel",
        Checkout: "Auschecken",
        UI: "UI",
        DataList: "Datenliste",
        ListView: "Listenansicht",
        ThumbView: "Daumenansicht",
        Grid: "Gitter",
        Vuexy: "Vuexy",
        Vuesax: "Vuesax",
        Tailwind: "Tailwind",
        Colors: "Farben",
        Card: "Karte",
        Basic: "Basic",
        Statistics: "Statistiken",
        Analytics: "Analytics",
        CardActions: "Kartenaktionen",
        CardColors: "Kartenfarben",
        Table: "Tabelle",
        agGridTable: "agGrid-Tabelle",
        Components: "Komponenten",
        Alert: "Warnen",
        Avatar: "Benutzerbild",
        Badge: "Abzeichen",
        Breadcrumb: "Breadcrumb",
        Button: "Taste",
        ButtonGroup: "Schaltflächengruppe",
        Chip: "Chip",
        Collapse: "Zusammenbruch",
        Dialogs: "Dialoge",
        Divider: "Teiler",
        DropDown: "Dropdown-Liste",
        List: "Liste",
        Loading: "Wird geladen",
        Navbar: "Navbar",
        Notifications: "Benachrichtigungen",
        Pagination: "Seitennummerierung",
        Popup: "Pop-up",
        Progress: "Fortschritt",
        Sidebar: "Seitenleiste",
        Slider: "Schieberegler",
        Tabs: "Tabs",
        Tooltip: "QuickInfo",
        Upload: "Hochladen",
        FormsAndTable: "Formulare und Tabelle",
        FormElements: "Formularelemente",
        Select: "Wählen",
        Switch: "Schalter",
        Checkbox: "Ankreuzfeld",
        Radio: "Radio",
        Input: "Eingang",
        NumberInput: "Nummer eingeben",
        Textarea: "Textbereich",
        FormLayouts: "Formularlayouts",
        FormWizard: "Formzauberer",
        FormValidation: "Formularvalidierung",
        FormInputGroup: "Formulareingabegruppe",
        Pages: "Seiten",
        Authentication: "Authentifizierung",
        Login: " تسجيل دخول ",
        Register: "نسجيل",
        ForgotPassword: "نسيت كلمة المرور؟",
        ResetPassword: "اعادة تعيين كلمة المرور",
        LockScreen: "Bildschirm sperren",
        Miscellaneous: "Verschiedenes",
        ComingSoon: "Demnächst",
        404: "404",
        500: "500",
        NotAuthorized: "Nicht berechtigt",
        Maintenance: "Instandhaltung",
        Profile: "صفحتي",
        Invoice: "Rechnung",
        FAQ: "FAQ",
        Search: "بحث",
        KnowledgeBase: "Wissensbasis",
        ChartsAndMaps: "Diagramme und Karten",
        Charts: "Diagramme",
        ApexCharts: "Apex Charts",
        chartjs: "chartjs",
        echarts: "echarts",
        chartist: "chartist",
        GoogleMap: "Google Karte",
        Extensions: "Erweiterungen",
        QuillEditor: "Quill-Editor",
        DragAndDrop: "Ziehen und loslassen",
        Datepicker: "Datumsauswahl",
        DatetimePicker: "Datum / Uhrzeit-Auswahl",
        AccessControl: "Zugangskontrolle",
        I18n: "I18n",
        Carousel: "Karussell",
        Clipboard: "Zwischenablage",
        ContextMenu: "Kontextmenü",
        StarRatings: "Sterne Bewertungen",
        Autocomplete: "Autovervollständigung",
        Tree: "Baum",
        Import: "Einführen",
        Export: "Export",
        ExportSelected: "Auswahl exportieren",
        Others: "Andere",
        MenuLevels: "Menüebenen",
        MenuLevel2p1: "Menüebene 2.1",
        MenuLevel2p2: "Menüebene 2.2",
        MenuLevel3p1: "Menüebene 3.1",
        MenuLevel3p2: "Menüebene 3.2",
        DisabledMenu: "Deaktiviertes Menü",
        Support: "Unterstützung",
        Documentation: "Dokumentation",
        RaiseSupport: "Unterstützung erheben",
        demoTitle: "Kartentitel",
        demoText: "Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.",
        TermsOfUse: "Gebruiks voor waarden",
        PrivacyPolicy: "Privacy beleid",
        Imprints: "Opdrukken",
    },
};